exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "li[_v-496547dc]{margin-bottom:1em}li a[_v-496547dc]{color:#777}li a.active[_v-496547dc]{color:#0b4a7e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-496547dc&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/filter-list.vue
// module id = 302
// module chunks = 0